import { getEnvConfig } from "env/getEnvConfig";

export const replaceIpfsHost = (str: string) => {
    const hostname = getEnvConfig().ipfsHost;
    return str
        .replace("https://ipfs.io", `https://${hostname}`)
        .replace("ipfs://", `https://${hostname}/ipfs/`);
};
